import React from 'react';
//import EgenDokumentasjonsDropdown from '../egenDokumentasjonsDropdown';
import { useRetrieveOrderedProductsGraphQL } from '../../hooks/vp/orderedProducts';
import Loader from '../loader';
import CSS from './OPDropdown.module.css';
import VpDokumentasjonsDropdown from '../vpAdminDokuDropdown';
import { useParams } from 'react-router-dom';

export function OrderedProductsDropdown() {

    const { id } = useParams();
    const {products, isLoading, isError} = useRetrieveOrderedProductsGraphQL(id);
            
    console.log('ORDERED PRODUCTS', products);

    const formatDate = (date) => {
      if (!date) return '';
      const options = { year: 'numeric', month: 'long' }; // Specify the format
      return new Date(date).toLocaleDateString('nb-NO', options);
    };

    const getCategoryTitle = (categoryId) => {
        switch (categoryId) {
          case 3:
            return "LAKKANLEGG";
          case 4:
            return "RETTE-OG-LØFTEUTSTYR";
          // Legg til flere saker for andre kategori-id-er
          case 5:
            return "VENTILASJON OG KOMPRESSOR";
          case 6:
            return "I BLANDEROM";
          case 7:
            return "DIVERSE";
          case 8:
            return "SVEISEUTSTYR";
          default:
            return "Ukjent kategori"; 
        }
      };

    const productsByCategory = products.reduce((acc, product) => {
        const categoryId = product?.attributes?.product?.data?.attributes?.category?.data?.id;

        if (!acc[categoryId]) {
            acc[categoryId] = [];
        }

        acc[categoryId].push(product);
        return acc;
    }, {});

    if(isLoading || !products) {
        return(<div><Loader /></div>)
    }

    if(isError) {
        return (<alert>Oida, noe gikk galt! Vennligst last inn siden på nytt</alert>)
    }

    if(!products.length) {
        return(<div>Ingen produkter tilgjengelig</div>)
    }
    
    if(products) {

      const {first_time_delivery, product_delivered_date} = products[0].attributes;

      const defaultDate = new Date('2024-05-01');
      
      const lastService = product_delivered_date ? new Date(product_delivered_date) : (first_time_delivery ? new Date(first_time_delivery) : defaultDate);
      const formattedLastService = formatDate(lastService);

      const dateToService = new Date(lastService);

      dateToService.setFullYear(lastService.getFullYear() + 1);

      const formattedDateToService = formatDate(dateToService);


    return(
        
        <div className="col-xl-12 m-auto">
          <div className='my-5'>
            <div className={CSS.service}>FORRIGE SERVICE: {formattedLastService}</div>
            <div className={CSS.service}>NESTE SERVICE: estimert {formattedDateToService}</div>
          </div>
          <div className="mt-5">
            <h1>
              PRODUKTOVERSIKT
            </h1>
            <p className={CSS.p}>Her finner du en liste over dine produkter</p>
          </div>
            {Object.keys(productsByCategory).map((categoryId) => (
                <VpDokumentasjonsDropdown
                key={categoryId}
                title={getCategoryTitle(parseInt(categoryId))}
                products={productsByCategory[categoryId]}
                />
            ))}
            <div className="mb-5"></div>
        </div>

    )
  }

}

export default OrderedProductsDropdown;